import React from "react";
import "../../Asstes/Brand/loader.css";
const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};
export default Loader;
